(() => {
  const STORAGE_KEY = 'bgf-color-mode';
  const SYSTEM = 'system';
  const LIGHT = 'light';
  const DARK = 'dark';
  const root = document.documentElement;
  const colorSchemeQuery = '(prefers-color-scheme: dark)';
  const colorSchemeMedia = typeof window.matchMedia === 'function' ? window.matchMedia(colorSchemeQuery) : null;

  const normalizePreference = (value) => (value === LIGHT || value === DARK ? value : SYSTEM);

  const readStoredPreference = () => {
    try {
      return normalizePreference(window.localStorage.getItem(STORAGE_KEY));
    } catch (error) {
      return SYSTEM;
    }
  };

  let preference = root.dataset.colorModePreference
    ? normalizePreference(root.dataset.colorModePreference)
    : readStoredPreference();

  const getSystemMode = () => (colorSchemeMedia?.matches ? DARK : LIGHT);
  const getEffectiveMode = () => (preference === SYSTEM ? getSystemMode() : preference);
  const getNextMode = () => (getEffectiveMode() === DARK ? LIGHT : DARK);

  const updateControls = () => {
    const mode = getEffectiveMode();
    const nextMode = getNextMode();

    document.querySelectorAll('[data-color-mode-toggle]').forEach((control) => {
      const modeLabel = control.dataset[`mode${mode[0].toUpperCase()}${mode.slice(1)}`];
      const nextModeLabel = control.dataset[`mode${nextMode[0].toUpperCase()}${nextMode.slice(1)}`];
      const label = control.dataset.actionTemplate
        .replace('__MODE__', modeLabel)
        .replace('__NEXT_MODE__', nextModeLabel);
      control.setAttribute('aria-label', label);
      control.setAttribute('title', label);
    });
  };

  const applyPreference = (nextPreference, { persist = false, announce = true } = {}) => {
    preference = normalizePreference(nextPreference);
    const mode = getEffectiveMode();

    root.dataset.colorModePreference = preference;
    root.dataset.colorMode = mode;
    root.style.colorScheme = mode;

    if (persist) {
      try {
        if (preference === SYSTEM) {
          window.localStorage.removeItem(STORAGE_KEY);
        } else {
          window.localStorage.setItem(STORAGE_KEY, preference);
        }
      } catch (error) {
        // Keep the in-memory preference when storage is unavailable.
      }
    }

    updateControls();

    if (announce) {
      document.dispatchEvent(
        new CustomEvent('color-mode:change', {
          detail: { mode, preference },
        })
      );
    }
  };

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-color-mode-toggle]');
    if (!control) return;
    const nextMode = getNextMode();
    const nextPreference = nextMode === getSystemMode() ? SYSTEM : nextMode;
    applyPreference(nextPreference, { persist: true });
  });

  const handleSystemChange = () => {
    if (preference === SYSTEM) applyPreference(SYSTEM);
  };

  if (colorSchemeMedia?.addEventListener) {
    colorSchemeMedia.addEventListener('change', handleSystemChange);
  } else if (colorSchemeMedia?.addListener) {
    colorSchemeMedia.addListener(handleSystemChange);
  }

  window.addEventListener('storage', (event) => {
    if (event.key !== STORAGE_KEY) return;
    applyPreference(event.newValue);
  });

  document.addEventListener('shopify:section:load', updateControls);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updateControls(), { once: true });
  } else {
    updateControls();
  }

  applyPreference(preference, { announce: false });
})();
